import { Checkbox as CheckboxChakra } from "@chakra-ui/react";
import { FaCheckCircle, FaRegCircle } from "react-icons/fa";

const Checkbox = ({
  onChange,
  isChecked,
  label,
  variant,
  ...rest
}) => {
  if (variant === "secondary") {
    return (
      <CheckboxChakra
        onChange={onChange}
        isChecked={isChecked}
        icon={isChecked ? <FaCheckCircle background="transparent" color="#fff" /> : <FaRegCircle />}
        background="transparent"
        outline="none"
        boxShadow="none"
        color="gray.100"
        {...rest}
        sx={{
          "> span": {
            border: "none",
            background: "transparent !important",
          },
          "> span[data-checked]": {
            background: "transparent",
          },
          "> span[data-hover]": {
            background: "transparent",
          },
          ...rest?.sx,
        }}
      >
      {label}
    </CheckboxChakra>
    )
  }

  return (
    <CheckboxChakra
      onChange={onChange}
      isChecked={isChecked}
      color="gray.100"
      {...rest}
    >
    {label}
    </CheckboxChakra>
  );
}

export default Checkbox;
